module.exports = __webpack_public_path__ + "img/sci_american_article_button.5ff68f01.jpg";